import React, {useEffect, useState, useRef, forwardRef, useImperativeHandle} from "react";
import styled from "styled-components";
import Popup from "../Popup";

export const Custom = forwardRef((props, ref) => {
	const popupRef = useRef();
	const [visible, setVisible] = useState(false);

	useEffect(() => {
		return () => {
			setVisible(false);
		};
	}, []);

	useImperativeHandle(ref, () => ({
		close : () => {
			popupRef.current.close();
		}
	}));

	const eventHandler = {
		open : () => {
			setVisible(true);
		},
		close : () => {
			setVisible(false);
		},
	};

	const render = () => {
		return (
			<Wrapper {...props}>
				<div onClick={eventHandler.open}>
					{props.children}
				</div>
				<StyledPopup ref={popupRef} open={visible} onClose={setVisible} onRender={props.onRender}>
					<div>
						{props.element}
					</div>
				</StyledPopup>
			</Wrapper>
		);
	};

	return render();
});

const Wrapper = styled.div``;

const StyledPopup = styled(Popup)`
& > div 	{max-height:80vh; overflow-x:hidden; overflow-y:auto}
`;

export default Custom;